import { State, Effect, Actions, dispatch } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import {convertToJalali, convertToGregorian} from '../utils/dateHelper'
import qs from 'qs'

const UserState = State({
  initial: {
    currentUser: null
  },
  setCurrentUser (state, payload) {
    // NOTICE: dates supposed to be gregorian
    payload.birthday = payload.birthday === '' ? '' : convertToJalali(payload.birthday)
    Object.keys(payload).forEach((key) => { payload[key] = payload[key] === null ? '' : payload[key] })
    return {
      currentUser: payload
    }
  }
})

// eslint-disable-next-line
const signupEffect = Effect('signup', (userData) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.post(`${apiAddress}user/signup`, qs.stringify(userData))
})

// eslint-disable-next-line
const userInfoEffect = Effect('userInfo', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}user/info`).then((res) => {
    Actions.setCurrentUser(res.data)
    return res.data
  }).catch((e) => {
    if (e.response.status === 401) {
      Actions.logout()
    }
  })
})

// eslint-disable-next-line
const changePasswordEffect = Effect('changePassword', (values) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.put(`${apiAddress}user/change-password`, values)
})

// eslint-disable-next-line
const userUpdateEffect = Effect('userUpdate', (user) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  user.birthday = convertToGregorian(user.birthday)
  return axios.put(`${apiAddress}user/info`, user).then((res) => {
    Actions.setCurrentUser({...UserState, ...user})
    return res.data
  })
})

// eslint-disable-next-line
const resetPasswordEffect = Effect('resetPassword', (values) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.put(`${apiAddress}user/reset-password`, values)
})

// eslint-disable-next-line
const userActiveEffect = Effect('userActive', (values) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.put(`${apiAddress}user/activation`, values)
})

//eslint-disable-next-line
const uploadAvatarEffect = Effect('uploadAvatar', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })

  var source = axios.CancelToken.source()
  const config = {
    onUploadProgress: params.progress,
    cancelToken: source.token
  }
  params.requestSetter(source)
  return axios.post(`${apiAddress}user/change-avatar`, params.data, config).then((res) => {
    return Actions.userInfo().then((resinfo) => {
      return res
    })
  }).catch((err) => {
    if (axios.isCancel(err)) {
      return Promise.reject(Error('آپلود به درخواست شما لغو شد'))
    }
    if (err.response.status === 422 && err.response.data.errors.file !== undefined) {
      return Promise.reject(err.response.data.errors.file[0])
    }
    return Promise.reject(Error('در آپلود آواتار مشکلی پیش آمده است، دوباره تلاش کنید.'))
  })
})

export default UserState



// WEBPACK FOOTER //
// ./src/states/user.js